import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ReportForm from "@/modules/report/admin/components/ReportForm";

export const Route = createFileRoute(
  "/admin/_panel/_report/report/reports/create",
)({
  component: Component,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "report.report.create");

    return {
      compactMenu: true,
      hideCrumb: true,
      crumb: [
        {
          label: context.t("Create report", { ns: "report.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
});

function Component() {
  return <ReportForm />;
}
